var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2658",
    "data-name": "Group 2658",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.343,
    height: 18,
    viewBox: "0 0 14.343 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1761",
    "data-name": "Rectangle 1761",
    width: 14.343,
    height: 18,
    fill: "#474747"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2657",
    "data-name": "Group 2657",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3709",
    "data-name": "Path 3709",
    d: "M12.312,0H2.03A2.029,2.029,0,0,0,0,2.03V15.969A2.03,2.03,0,0,0,2.03,18H12.312a2.031,2.031,0,0,0,2.031-2.031V2.03A2.03,2.03,0,0,0,12.312,0M3.5,9.773a.747.747,0,1,1,0-1.494h7.4a.747.747,0,0,1,0,1.494Zm.844,2.84a.661.661,0,1,1-.66-.661.661.661,0,0,1,.66.661M2.7,5.389a.747.747,0,0,1,.747-.747h7.406a.747.747,0,0,1,0,1.494H3.451A.747.747,0,0,1,2.7,5.389",
    fill: "#474747"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatement);
export default __webpack_public_path__ + "static/media/statement.4afc780c662090157d16846dcd312095.svg";
export { ForwardRef as ReactComponent };